import AlertDialogComponent from "./components/alertDialog";
import ConfirmDialogComponent from "./components/confirmDialog";

const ConfirmDialogPlugin = {
    install(Vue) {
        this.alertBus = new Vue();
        this.confirmBus = new Vue();

        Vue.component("alert-dialog", AlertDialogComponent);
        Vue.prototype.$alert = function (options) {
            return new Promise(resolve => {
                ConfirmDialogPlugin.alertBus.$once("close", params => resolve(params));
                ConfirmDialogPlugin.alertBus.$emit("show", options);
            });
        };

        Vue.component("confirm-dialog", ConfirmDialogComponent);
        Vue.prototype.$confirm = function (options) {
            return new Promise(resolve => {
                ConfirmDialogPlugin.confirmBus.$once("close", params => resolve(params));
                ConfirmDialogPlugin.confirmBus.$emit("show", options);
            });
        };
    }
};

export default ConfirmDialogPlugin;